/**
 * The sidebar's pages: one label and path each. The sidebar renders these, and
 * the header breadcrumb names the page you are on with the same label.
 */
export interface NavItem {
  label: string;
  path: string;
}

export const NAV_ITEMS = {
  rogerDocOverview: { label: 'Overview', path: '/rogerdoc/overview' },
  rogerDocUsers: { label: 'Users', path: '/rogerdoc/users' },
  rogerDocUsage: { label: 'Usage', path: '/rogerdoc/usage' },
  customizations: { label: 'Customizations', path: '/customizations' },
  formsManager: { label: 'Forms Manager', path: '/form-schemas' },
  resources: { label: 'Resources', path: '/resources' },
  // Unlisted prototype: /qa route remains; sidebar entry intentionally hidden (EMR-3225).
  qualityAssurance: { label: 'Quality Assurance', path: '/qa' },
  hotbox: { label: 'Hotbox', path: '/hotbox' },
  dashboard: { label: 'Dashboard', path: '/dashboard' },
  intakeManager: { label: 'Intake Manager', path: '/intake-manager' },
  medicalCoding: { label: 'Medical Coding', path: '/coding' },
  patientManager: { label: 'Patient Manager', path: '/patients' },
  ordersManager: { label: 'Orders Manager', path: '/orders' },
  oasisManager: { label: 'OASIS Manager', path: '/oasis-manager' },
  faxInbox: { label: 'Fax Inbox', path: '/fax-inbox' },
  noaManager: { label: 'NOA Manager', path: '/noa-manager' },
  worksheetGoals: { label: 'Worksheet Goals', path: '/worksheet-goals' },
  payrollManager: { label: 'Payroll Manager', path: '/payroll-manager' },
  userManager: { label: 'User Manager', path: '/user-manager' },
  reports: { label: 'Reports', path: '/reports' },
  billingManager: { label: 'Billing Manager', path: '/billing' },
  authManager: { label: 'Auth Manager', path: '/auth-manager' },
  admin: { label: 'Admin', path: '/admin' },
  rolesManager: { label: 'Roles & Permissions', path: '/roles-manager' },
  internalAdmin: { label: 'Internal Admin', path: '/internal-admin' },
  importer: { label: 'Importer', path: '/importer' },
  testing: { label: 'Testing', path: '/testing' },
  internalTools: { label: 'Internal Tools', path: '/internal-tools' },
} as const satisfies Record<string, NavItem>;
